
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/policy-two",
      function () {
        return require("private-next-pages/fr/policy-two.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/policy-two"])
      });
    }
  